import React from 'react';
import styles from "../schedulePOComps/Potable.module.css";
import { Package, Layers } from 'lucide-react';

const PoOrderTable = ({ data = [] }) => {
    const formatPrice = (val) => {
        const num = Number(val) || 0;
        return `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    return (
        <div className={styles.previewContainer}>
            <div className={styles.tableHeaderBar}>
                <h3 className={styles.tableTitle}>
                    <Layers size={18} color="#512DA8" />
                    PO Part List
                </h3>
                <span className={styles.itemCountBadge}>
                    {data?.length || 0} {data?.length === 1 ? 'Part' : 'Parts'}
                </span>
            </div>

            <table className={styles.previewtable}>
                <thead>
                    <tr>
                        <th className={styles.previewth} style={{ width: '35%' }}>Part Details</th>
                        <th className={styles.previewth} style={{ width: '20%' }}>Manufacturer</th>
                        <th className={styles.previewth} style={{ width: '12%' }}>Quantity</th>
                        <th className={styles.previewth} style={{ width: '13%' }}>Unit Quote</th>
                        <th className={styles.previewth} style={{ width: '10%' }}>MOQ</th>
                        <th className={styles.previewth} style={{ width: '10%', textAlign: 'right' }}>Subtotal</th>
                    </tr>
                </thead>
                <tbody>
                    {data && data.length > 0 ? (
                        data.map((item, index) => {
                            const partNo = item?.productNumber || '-';
                            const manufacturerName = item?.manufacturer || '-';
                            const quotePrice = item?.quotePrice || 0;
                            const subtotal = (item?.quantity || 0) * quotePrice;

                            return (
                                <tr key={item?.id || item?._id || index} className={styles.previewstripedRow}>
                                    <td className={styles.previewtd}>
                                        <div className={styles.productCell}>
                                            <div className={styles.productImgBox}>
                                                <Package size={22} color="#94A3B8" />
                                            </div>
                                            <div className={styles.productInfoWrap}>
                                                <span className={styles.partNumberText}>{partNo}</span>
                                                <span className={styles.skuText}>Line #{index + 1}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td className={styles.previewtd}>
                                        <span className={styles.manufacturerBadge}>{manufacturerName}</span>
                                    </td>
                                    <td className={styles.previewtd}>
                                        <span className={styles.quantityBadge}>{item?.quantity?.toLocaleString('en-IN') || 0}</span>
                                    </td>
                                    <td className={styles.previewtd}>
                                        <span className={styles.unitPriceText}>{formatPrice(quotePrice)}</span>
                                    </td>
                                    <td className={styles.previewtd}>
                                        <span style={{ fontSize: '13px', color: '#64748B', fontWeight: 500 }}>
                                            {item?.moq || '-'}
                                        </span>
                                    </td>
                                    <td className={styles.previewtd} style={{ textAlign: 'right' }}>
                                        <span className={styles.subtotalText}>{formatPrice(subtotal)}</span>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="6" style={{ textAlign: 'center', padding: '36px 20px', color: '#64748B' }}>
                                <Package size={28} style={{ margin: '0 auto 8px', color: '#CBD5E1', display: 'block' }} />
                                No PO items found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default PoOrderTable;